import { gql } from '@edreamsodigeo/frontend-api-client';

export const getShoppingBundleWithBookingId = gql`
  query getPFShoppingBundleConfirmation(
    $shoppingBundleRequest: ShoppingBundleRequest
    $getShoppingBookingIdRequest: GetShoppingBookingIdRequest
    $itineraryPriceFreezeRevenueDataRequest: ItineraryPriceFreezeRevenueDataRequest
  ) {
    getShoppingBundle(request: $shoppingBundleRequest) {
      shoppingId
      buyer {
        name
        lastNames
        mail
      }
      products {
        id {
          id
          type
        }
        price {
          amount
          currency
        }
        ... on PriceFreezeShoppingBundleProduct {
          productInfo {
            frozenPrice {
              amount
              currency
            }
          }
        }
      }
    }
    getShoppingBookingId(request: $getShoppingBookingIdRequest)
    itineraryPriceFreezeRevenueData(
      itineraryPriceFreezeRevenueDataRequest: $itineraryPriceFreezeRevenueDataRequest
    ) {
      itineraryPriceFreezeId
      revenue {
        amount
        currency
      }
      redemptionRate
    }
  }
`;

export const getRepricingFromShoppingBundle = gql`
  query getPriceFreezeRepricing($request: ShoppingBundleRequest) {
    getShoppingBundle(request: $request) {
      repricing {
        difference
      }
    }
  }
`;

export const createShoppingBundle = gql`
  mutation createShoppingCartForPriceFreeze(
    $request: CreateShoppingBundleRequest!
  ) @silent {
    createShoppingBundle(request: $request) {
      shoppingBundle {
        shoppingId
      }
    }
  }
`;
